import React, { useState } from 'react';
import { ContentLayout } from 'components/Layout';
import { useAuth } from 'lib/auth';

export const Dashboard = () => {
  const { user } = useAuth();

  // State for the Recent Deposits filter
  const [depositFilter, setDepositFilter] = useState('10K Project');
  // State for the Payment Statistics date range filter
  const [dateRange, setDateRange] = useState('Last 7 Days');

  // Dummy handler for exporting PDF
  const handleExportPDF = () => {
    // Implement your PDF export logic here.
    console.log('Export PDF clicked');
  };

  return (
    <ContentLayout>
      {/* Welcome Message */}
      <div className="mb-6">
        <div className="text-lg font-light text-gray-600">Welcome back,</div>
        <div className="text-3xl font-bold text-gray-900">{user?.firstName} 😎</div>
      </div>

      {/* Dashboard Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-10">
        <div className="bg-white shadow rounded-lg p-6">
          <div className="text-sm text-gray-500">Unique Visitors</div>
          <div className="text-2xl font-bold text-gray-900">0</div>
        </div>
        <div className="bg-white shadow rounded-lg p-6">
          <div className="text-sm text-gray-500">All Visitors</div>
          <div className="text-2xl font-bold text-gray-900">0</div>
        </div>
        <div className="bg-white shadow rounded-lg p-6">
          <div className="text-sm text-gray-500">Active Users</div>
          <div className="text-2xl font-bold text-gray-900">0</div>
        </div>
        <div className="bg-white shadow rounded-lg p-6">
          <div className="text-sm text-gray-500">WLU Account Balance</div>
          <div className="text-2xl font-bold text-gray-900">UGX 0</div>
        </div>
        <div className="bg-white shadow rounded-lg p-6">
          <div className="text-sm text-gray-500">New Members</div>
          <div className="text-2xl font-bold text-gray-900">0</div>
        </div>
        <div className="bg-white shadow rounded-lg p-6">
          <div className="text-sm text-gray-500">Total Payments</div>
          <div className="text-2xl font-bold text-gray-900">0</div>
        </div>
      </div>

      {/* Recent Deposits Section */}
      <div className="mb-10">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-2xl font-semibold text-gray-800">Recent Deposits</h2>
            <div className="text-md text-gray-600">Displaying recent deposits by members.</div>
          </div>
          <div>
            <select
              value={depositFilter}
              onChange={(e) => setDepositFilter(e.target.value)}
              className="border border-gray-300 rounded-md p-2 text-sm"
            >
              <option value="10K Project">10K Project</option>
              <option value="Satellite City">Satellite City</option>
              <option value="Pearl Life">Pearl Life</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-5 text-center">
          <em className="text-gray-500">No recent deposits to display.</em>
        </div>
      </div>

      {/* Payment Statistics Section */}
      <div className="mb-10">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-semibold text-gray-800">Payment Statistics</h2>
          <div className="flex items-center space-x-4">
            <select
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
              className="border border-gray-300 rounded-md p-2 text-sm"
            >
              <option value="Last 7 Days">Last 7 Days</option>
              <option value="Last 30 Days">Last 30 Days</option>
              <option value="This Month">This Month</option>
              <option value="This Year">This Year</option>
            </select>
            <button
              onClick={handleExportPDF}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm"
            >
              Export PDF
            </button>
          </div>
        </div>
        <div className="bg-white shadow rounded-lg p-6">
          {/* Replace this placeholder with your payment statistics graph component */}
          <div className="h-64 flex items-center justify-center text-gray-500">
            [Payment Statistics Graph]
          </div>
        </div>
      </div>

      {/* Member Statistics Section */}
      <div className="mb-10">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Member Statistics</h2>
        <div className="bg-white shadow rounded-lg p-6">
          {/* Replace this placeholder with your member statistics line graph component */}
          <div className="h-64 flex items-center justify-center text-gray-500">
            [Member Statistics Line Graph]
          </div>
          <div className="mt-4 grid grid-cols-2 gap-4 text-sm text-gray-600">
            <div>New Members</div>
            <div>Old Members</div>
            <div>Active Members</div>
            <div>Inactive Members</div>
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};
